import Fetch, { serializeQueryString } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';
import { stockBannerInfo, stockSREUrl, stockTradelimitUrl } from './_endpoint';

const fetchGet = (url, { query } = {}) =>
  Fetch.get(`${url}${serializeQueryString(query)}`)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: url });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });

export const getStockSRE = () => fetchGet(stockSREUrl);

export const getStockTradelimit = () => fetchGet(stockTradelimitUrl);

export const getBannerInfoProfile = () => fetchGet(stockBannerInfo);
